import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-change-password-success',
    templateUrl: './change-password-success.component.html',
    standalone: false
})
export class ChangePasswordSuccessComponent implements OnInit {

  constructor(
    public translate: TranslateService
  ) { }

  ngOnInit() { }

}
